<script setup lang="ts">
import BaseModal from '@/components/base/BaseModal.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { useTemplateRef } from 'vue'
import { useAppStore } from '@/stores/app'
import { storeToRefs } from 'pinia'
const { showLearning } = storeToRefs(useAppStore())

const modalRef = useTemplateRef('modalRef')

const open = () => {
  modalRef.value?.open()
}

const close = () => {
  modalRef.value?.close()
}

const openFTUE = () => {
  close()
  setTimeout(() => {
    showLearning.value = true
  }, 100)
}

const openPDF = () => {
  close()
  setTimeout(() => {
    window.open('https://psi-curriculum.yellowcowries.com/', '_blank')
  }, 100)
}

defineExpose({
  open,
  close
})
</script>

<template>
  <BaseModal ref="modalRef" class="lg:px-16">
    <div class="text-center">
      <h2 class="text-xl lg:text-2xl font-bold text-white mb-4 lg:mb-7">Tutorial</h2>
      <div class="grid grid-cols-1 gap-y-4 lg:gap-y-6 xl:gap-y-8 items-center *:!w-full">
        <BaseButton background-color="#1AA570" border-color="var(--color-cw-green-border-shadow)" class="md:px-4 md:py-2.5 lg:px-6 lg:py-3.5" @click="openFTUE">
          <p class="w-full !text-sm md:!text-base xl:!text-xl">How to play</p>
        </BaseButton>
        <BaseButton background-color="var(--color-cw-indigo)" border-color="#1F2547" @click="openPDF" class="md:px-4 md:py-2.5 lg:px-6 lg:py-3.5">
          <p class="w-full !text-sm md:!text-base xl:!text-xl">PSI Curriculum</p>
        </BaseButton>
      </div>
    </div>
  </BaseModal>
</template>
